import { Component } from '@angular/core';

@Component({
  selector: 'pc-services-circles',
  standalone: true,
  imports: [],
  templateUrl: './services-circles.component.html',
  styleUrl: './services-circles.component.scss'
})
export class ServicesCirclesComponent {

}
